import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { Outlet } from "react-router";
import { BasePage } from "../../components/molecules/BasePage";
export function StoresPage() {
    return (_jsx(BasePage, { children: _jsx(Suspense, { children: _jsx(Outlet, {}) }) }));
}
